import { Validators }                from '@angular/forms';
import { Caisse }                    from '@shared/classes/caisse';
import { Produit }                   from '@shared/classes/produit';
import { User }                      from '@shared/classes/user';
import { isProduction }              from 'src/app/shared/constants/sharedFrontConstants';
import { FORMAT_TO, FormatDateEnum } from '@shared/enums/date.enum';
import { format }                    from '@shared/helper/DateHelper';
import { stringIsNotNull }           from '@shared/helper/LDHelper';
import { LoggerFront }               from 'src/app/shared/logger/loggerFront';
import { GenericTagsObjInterface }   from 'src/app/shared/services/trackingService/genericTagsObjInterface';

export type TypeDialogRappelConseiller = {
  user: User,
  fileNamePdf: string
  produits: Produit[]
}

export const GENERIC_TAGS_OBJ_INTERFACE = (user: User, trigrammeCaisse: string): GenericTagsObjInterface => {
  return {
    civilite:             user.civilite,
    hash_nom:             user.nom,
    hash_prenom:          user.prenom,
    date_naissance:       format (FormatDateEnum.FRENCH_FORMAT, FORMAT_TO.STRING, user.dateDeNaissance) as Date,
    profession:           user.profession,
    enfants:              user.enfant,
    nb_enfants_moins_18:  user.enfantsMoinsDixHuitAns,
    conjoint:             user.conjoint,
    emprunt_immo:         user.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT === 'Non' ? 'non' : 'oui',
    emprunt_immo_plus_15: user.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE,
    assurance_obseques:   user.OBSEQUES,
    assurance_gav:        user.GAV,
    trigrammeCaisse:      trigrammeCaisse,
  };

};


export const index_cp = {
  97:      3,
  DEFAULT: 2,
};

export const CAISSE = (cp: string, caisses: Caisse[]): Caisse => {
  let caisse = null;
  if (stringIsNotNull (cp) && cp.length > 1) {
    const cp2String = cp.substring (0, 2);
    const cpNumber  = parseInt (cp2String);
    let cpToFound   = cp2String;
    if (cpNumber === 97 && cp.length > 2) {
      const go  = parseInt (cp.substring (0, 3));
      cpToFound = '971';
      if (go >= 974 && go <= 976) {
        cpToFound = '974';
      }
    }
    caisse = caisses.find (c => c.Departement === cpToFound);
    if (!caisse) {
      LoggerFront.warn (`no caisse found for cp [${cp}]`);
    }
  }
  return caisse;
};

export const VALIDATORS_SELFCARE = {
  identifiant: [(''), Validators.compose ([Validators.required])],
  password:    [(''), Validators.compose ([Validators.required])],
  caisse:      [(''), Validators.compose ([Validators.required])],
  caisseGGVIE: [(''), Validators.compose ([Validators.required])],
};

export const DIALOG_RAPPEL_CONSEILLER = (e: TypeDialogRappelConseiller) => {
  return {
    disableClose: true,
    hasBackdrop:  true,
    maxWidth:     '100vw',
    width:        '750px',
    autoFocus:    false,
    position:     {
      top: isProduction () ? '1700px' : null,
    },
    data:         {
      user:        e.user,
      fileNamePdf: e.fileNamePdf,
      produits:    e.produits,
    },
  };
};
